<div fxLayout="row" fxLayoutGap="40px" fxLayoutAlign="space-evenly center">
  <div
    *ngFor="let benefit of benefits"
    class="benefit"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutAlign.lt-lg="start center"
    (click)="openLink(benefit)"
    [class.clickable]="benefit.link"
  >
    <!-- icon -->
    <div *ngIf="benefit.icon" style="font-size: 60px; line-height: 75px">
      <i [class]="benefit.icon"></i>
    </div>

    <!-- image -->
    <div *ngIf="benefit.image">
      <img [src]="benefit.image" />
    </div>

    <div fxHide.gt-md [innerHTML]="benefit.content_mobile"></div>
    <div fxHide.lt-lg>{{ benefit.content_desktop }}</div>
  </div>
</div>
